/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { storeAggregatorOnboarding } from '../fn/store-aggregator-onboarding/store-aggregator-onboarding';
import { StoreAggregatorOnboarding } from '../models/store-aggregator-onboarding';
import { StoreAggregatorOnboarding$Params } from '../fn/store-aggregator-onboarding/store-aggregator-onboarding';
import { StoreAggregatorOnboardingGetResponse } from '../models/store-aggregator-onboarding-get-response';
import { storesStoreIdOnboardingAggregatorsAggregatorIdPut } from '../fn/store-aggregator-onboarding/stores-store-id-onboarding-aggregators-aggregator-id-put';
import { StoresStoreIdOnboardingAggregatorsAggregatorIdPut$Params } from '../fn/store-aggregator-onboarding/stores-store-id-onboarding-aggregators-aggregator-id-put';

@Injectable({ providedIn: 'root' })
export class StoreAggregatorOnboardingService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `storesStoreIdOnboardingAggregatorsAggregatorIdPut()` */
  static readonly StoresStoreIdOnboardingAggregatorsAggregatorIdPutPath = '/stores/{storeId}/onboarding/aggregators/{aggregatorId}';

  /**
   * Updates a store's aggregator Onboarding status.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `storesStoreIdOnboardingAggregatorsAggregatorIdPut()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  storesStoreIdOnboardingAggregatorsAggregatorIdPut$Response(params: StoresStoreIdOnboardingAggregatorsAggregatorIdPut$Params, context?: HttpContext): Observable<StrictHttpResponse<StoreAggregatorOnboarding>> {
    return storesStoreIdOnboardingAggregatorsAggregatorIdPut(this.http, this.rootUrl, params, context);
  }

  /**
   * Updates a store's aggregator Onboarding status.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `storesStoreIdOnboardingAggregatorsAggregatorIdPut$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  storesStoreIdOnboardingAggregatorsAggregatorIdPut(params: StoresStoreIdOnboardingAggregatorsAggregatorIdPut$Params, context?: HttpContext): Observable<StoreAggregatorOnboarding> {
    return this.storesStoreIdOnboardingAggregatorsAggregatorIdPut$Response(params, context).pipe(
      map((r: StrictHttpResponse<StoreAggregatorOnboarding>): StoreAggregatorOnboarding => r.body)
    );
  }

  /** Path part for operation `storeAggregatorOnboarding()` */
  static readonly StoreAggregatorOnboardingPath = '/stores/{storeId}/onboarding';

  /**
   * Gets onboarding details for a store.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `storeAggregatorOnboarding()` instead.
   *
   * This method doesn't expect any request body.
   */
  storeAggregatorOnboarding$Response(params: StoreAggregatorOnboarding$Params, context?: HttpContext): Observable<StrictHttpResponse<StoreAggregatorOnboardingGetResponse>> {
    return storeAggregatorOnboarding(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets onboarding details for a store.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `storeAggregatorOnboarding$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  storeAggregatorOnboarding(params: StoreAggregatorOnboarding$Params, context?: HttpContext): Observable<StoreAggregatorOnboardingGetResponse> {
    return this.storeAggregatorOnboarding$Response(params, context).pipe(
      map((r: StrictHttpResponse<StoreAggregatorOnboardingGetResponse>): StoreAggregatorOnboardingGetResponse => r.body)
    );
  }

}
